import React from "react";
import LegalLayout from "../components/site/LegalLayout";
import { COMPANY } from "../data/site";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" eyebrow="Legal" testId="privacy-page">
      <p>
        {COMPANY.legalName} (“we”, “us”, “our”) operates the JayesPay web and
        mobile applications. We respect your privacy and are committed to
        protecting the personal data you share with us.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          <strong>Account data:</strong> name, mobile, email, password
          (hashed).
        </li>
        <li>
          <strong>KYC data:</strong> Aadhaar (eKYC), PAN, bank account details,
          photographs, business/shop photos, optional 10th certificate,
          cancelled cheque.
        </li>
        <li>
          <strong>Transaction data:</strong> recharges, bill payments, PAN
          applications, RD, BC and related details required to fulfil the
          service.
        </li>
        <li>
          <strong>Device & log data:</strong> device identifiers, IP, OS, app
          version, crash logs.
        </li>
      </ul>

      <h2>2. How We Use Your Data</h2>
      <ul>
        <li>To onboard, verify and activate your retailer account.</li>
        <li>To process transactions and route them to regulated partners.</li>
        <li>To prevent fraud, comply with law and protect platform integrity.</li>
        <li>To improve product features and provide support.</li>
      </ul>

      <h2>3. Sharing</h2>
      <p>
        We share data only with regulated partners (NSDL, UTIITSL, banks,
        billers, etc.) and service providers strictly to deliver the service
        you initiated. We do not sell your data.
      </p>

      <h2>4. Security</h2>
      <p>
        We follow industry-standard practices including encryption in transit,
        access controls, hashed credentials, T-PIN and App Lock to protect your
        data. No system is 100% secure; please use strong passwords and never
        share T-PIN.
      </p>

      <h2>5. Retention</h2>
      <p>
        We retain personal and transactional data for the period required by
        applicable law (including RBI, IT Act and KYC norms). You may request
        account deactivation as described in the{" "}
        <a href="/account-deactivation">Account Deactivation</a> page.
      </p>

      <h2>6. Your Rights</h2>
      <ul>
        <li>Access, correct or update your account information.</li>
        <li>Request deactivation and deletion (subject to retention norms).</li>
        <li>Withdraw consent where processing is consent-based.</li>
      </ul>

      <h2>7. Cookies & Analytics</h2>
      <p>
        We use cookies and similar technologies to keep you logged in, remember
        preferences and measure usage. You can disable cookies in your browser,
        though some features may stop working.
      </p>

      <h2>8. Children</h2>
      <p>
        JayesPay is intended for retailers aged 18+. We do not knowingly collect
        data from minors.
      </p>

      <h2>9. Changes</h2>
      <p>
        We may update this policy. The “Last updated” date at the top reflects
        the latest version.
      </p>

      <h2>10. Contact</h2>
      <p>
        Privacy questions: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
        · {COMPANY.phone}. Postal: {COMPANY.address}.
      </p>
    </LegalLayout>
  );
}
